<template>
    <div class="overflow-auto">
        <table>
            <tbody>
                <tr
                    v-for="(row, index) in data.datasets"
                    :key="index"
                >
                    <td class="text-small font-weight-semi-bold xAxis">
                        {{ row.name }}
                    </td>
                    <td
                        v-for="(data, indexCell) in row.data"
                        :key="`data-${index}-${indexCell}`"
                    >
                        <span
                            v-if="data.filled"
                            class="
                                d-flex
                                align-items-center
                                justify-content-center
                                m-auto
                                text-white
                                text-smaller
                                font-weight-semi-bold
                                stack-item
                            "
                            :style="{ backgroundColor: normalizeScoreColor(data.value, row.possible_values) }"
                        />
                        <span
                            v-else
                            class="d-flex m-auto stack-item"
                        />
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td />
                    <td
                        v-for="(label, index) in data.labels"
                        :key="`label-${index}`"
                        v-text="label"
                        class="pt-3 text-small text-center"
                    />
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
    name: 'WidgetStacked',
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        reverseColors: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: 7,
        },
    },
    methods: {
        normalizeScoreColor(data, possibleValues) {
            const index = possibleValues.findIndex(item => item === data);

            return this.getColorByScore(index, this.reverseColors, possibleValues.length);
        },
    },
}
</script>

<style lang="scss" scoped>
    table {
        tbody tr:nth-child(even) {
            background-color: transparent;
        }

        td {
            height: auto;
            padding: 1px 4px;
        }
    }

    .xAxis {
        max-width: 60px;
        white-space: normal;
    }

    .stack {
        &-item {
            width: 32px;
            height: 32px;
            background-color: $info;
        }
    }
</style>
